import * as React from "react";
import {
  Html5Qrcode,
  Html5QrcodeSupportedFormats,
  Html5QrcodeScanType,
} from "html5-qrcode";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import LoadingButton from "@mui/lab/LoadingButton";

import { Context } from "../context/DataContext";

let scanner = null;
const scannerElementId = "html5-qr-code-full-region";
const qrbox = (viewfinderWidth, viewfinderHeight) => {
  // Square QR Box, with size = 80% of the min edge.
  const minEdgeSizeThreshold = 250;
  const edgeSizePercentage = 0.8;
  const minEdgeSize =
    viewfinderWidth > viewfinderHeight ? viewfinderHeight : viewfinderWidth;
  const qrboxEdgeSize = Math.floor(minEdgeSize * edgeSizePercentage);

  if (qrboxEdgeSize < minEdgeSizeThreshold) {
    if (minEdgeSize < minEdgeSizeThreshold) {
      return {
        width: minEdgeSize,
        height: minEdgeSize * 0.2 < 50 ? 50 : minEdgeSize * 0.2,
      };
    } else {
      return {
        width: minEdgeSizeThreshold,
        height:
          minEdgeSizeThreshold * 0.2 < 50 ? 50 : minEdgeSizeThreshold * 0.2,
      };
    }
  }

  return {
    width: qrboxEdgeSize,
    height: qrboxEdgeSize * 0.2 < 50 ? 50 : qrboxEdgeSize * 0.2,
  };
};

const openCamera = (successCallback) => {
  scanner = new Html5Qrcode(scannerElementId, {
    formatsToSupport: [Html5QrcodeSupportedFormats.CODE_128],
  });
  scanner.start(
    { facingMode: "environment" },
    {
      fps: 10,
      qrbox,
      experimentalFeatures: {
        useBarCodeDetectorIfSupported: true,
      },
      supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
    },
    successCallback
  );
};

const closeCamera = () => {
  if (scanner) {
    scanner.stop();
    scanner = null;
  }
};

const IMEIPage = () => {
  const navigate = useNavigate();
  const {
    state: { customerInfo, loginInfo },
    getMobileGuaranteeInfo,
    setCustomerInfo,
    checkImei,
  } = React.useContext(Context);
  const [imei, setIMEI] = React.useState("");
  const [errorMsg, setErrorMsg] = React.useState("");
  const [isScanning, setIsScanning] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  return (
    <Box>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        手機IMEI或商品SN
      </Typography>
      <Box
        component='form'
        sx={{ px: 3, "& > :not(style)": { my: 1 } }}
        noValidate
        autoComplete='off'>
        <FormControl
          fullWidth
          variant='outlined'>
          <InputLabel htmlFor='outlined-adornment-imei'>IMEI</InputLabel>
          <OutlinedInput
            id='outlined-adornment-imei'
            type={"text"}
            value={imei}
            onChange={(e) => setIMEI(e.target.value)}
            endAdornment={
              isScanning ? null : (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle imei scanner visibility'
                    onClick={() => {
                      setIsScanning(true);
                      openCamera((decodedText) => {
                        setIMEI(decodedText);
                        setIsScanning(false);
                        closeCamera();
                      });
                    }}
                    edge='end'>
                    <QrCodeScannerIcon />
                  </IconButton>
                </InputAdornment>
              )
            }
            label='IMEI'
          />
        </FormControl>
        <Box id={scannerElementId} />
        {errorMsg ? (
          <Typography
            variant='h6'
            sx={{ my: 2, color: "red" }}>
            {errorMsg}
          </Typography>
        ) : null}
        <LoadingButton
          variant='contained'
          sx={{ width: 168 }}
          disabled={!imei}
          loading={loading}
          onClick={() => {
            setErrorMsg("");
            setLoading(true);
            // Check imei or sn every time
            checkImei(
              { imei, serviceName: customerInfo.imeiServiceName },
              ({ responseCode, responseMsg }) => {
                if (responseCode === "000") {
                  // Get Mobile Guarantee Info first, then navigate to check-order-info
                  getMobileGuaranteeInfo(
                    {
                      brand: customerInfo.brand,
                      capacity: customerInfo.capacity,
                      model: customerInfo.model,
                      market_n: customerInfo.market_n,
                      imei,
                      mdate: "X",
                      emp_no: loginInfo.empNo,
                    },
                    ({ responseCode, responseMsg }) => {
                      if (responseCode === "000") {
                        setCustomerInfo({ imei }, () => {
                          setLoading(false);
                          navigate("/check-order-info");
                        });
                      } else {
                        setLoading(false);
                        setErrorMsg(responseMsg);
                      }
                    }
                  );
                } else {
                  setLoading(false);
                  setErrorMsg(responseMsg);
                }
              }
            );
          }}>
          下一步
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default IMEIPage;
